import { defineStore } from 'pinia';
import { ref } from 'vue';

const PAGE_SIZES = [10, 20, 30, 40, 50] as const;

const notInIframe = window.self === window.top;

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    const passwordReset = ref(false); // Will be used in otp screen for redirect
    const passwordResetFallbackToWhatsApp = ref(false);
    const notifyUrl = ref('');
    const iFrame = ref(!notInIframe);
    const isMenuOpen = ref(false);
    const pageSize = ref(10);

    return { passwordReset, passwordResetFallbackToWhatsApp, notifyUrl, iFrame, isMenuOpen, pageSize };
  },
  persist: notInIframe,
  actions: {
    reset() {
      this.$reset();
    },
    getPageSizeOptions(): readonly number[] {
      return PAGE_SIZES;
    },
  },
});
